import { render, staticRenderFns } from "./participation.vue?vue&type=template&id=240cf5c3&scoped=true"
import script from "./participation.vue?vue&type=script&lang=js"
export * from "./participation.vue?vue&type=script&lang=js"
import style0 from "./participation.vue?vue&type=style&index=0&id=240cf5c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240cf5c3",
  null
  
)

export default component.exports